<!-- Client, entity or agrupation dropdown -->
<div
  #navbarTopDropdown
  class="navbar-top-dropdown-container"
  (click)="toggleVisibilityTrue()"
  (mouseenter)="toggleVisibilityTrue()"
  (mouseleave)="toggleVisibilityFalse()"
>
  <button class="navbar-top-dropdown-button dropdown-toggle">
    <i class="{{ classes }}"></i>
    {{ title | translate }} ({{ elementList?.length ?? 0 }})
  </button>
  @if (!currentElement) {
    <p class="navbar-top-selected">-</p>
  }
  @if (currentElement) {
    <div
      class="navbar-top-selected"
      [ngClass]="{ 'navbar-top-selected-reduced': currentElement.alias }"
    >
      <span>
        {{ currentElement[attributeShowed] }}
        @if (currentElement?.virtual) {
          @if (!currentElement?.showAllEntity) {
            <sup class="navbar-top-selected-virtual">
              <i class="fas fa-circle"></i>
              <span>V</span>
            </sup>
          } @else {
            <sup class="navbar-top-selected-total-virtual">
              <i class="fas fa-circle"></i>
              <span>V</span>
            </sup>
          }
        }
      </span>
      @if (currentElement.alias) {
        <span class="navbar-top-selected-alias">
          {{ currentElement.alias }}
        </span>
      }
    </div>
  }
  <div #dropdown class="navbar-top-dropdown">
    <!-- Client, entity or agrupation list -->
    @if (allowList) {
      <div
        [routerLink]="[listLink]"
        [ngClass]="{ disabled: !elementList || elementList.length === 0 }"
      >
        <i class="fa fa-list fa-fw navbar-top-dropdown-icon"></i>
        {{ "list" | translate }}
      </div>
    }
    <!-- New client, entity or agrupation -->
    @if (allowNew) {
      <div [routerLink]="[newLink]">
        <i class="fa fa-plus fa-fw navbar-top-dropdown-icon"></i>
        {{ "new" | translate }}
      </div>
    }
    @if (allowList || allowNew) {
      <hr class="material-menu-separator" />
    }
    <!-- Client, entity or agrupation filter -->
    @if (elementList) {
      <div class="navbar-top-dropdown-filter">
        <form class="navbar-top-form" autocomplete="off">
          <input
            #elementFilter
            class="navbar-top-dropdown-input"
            type="text"
            name="elementFilter"
            autocomplete="off"
            (keyup)="dropdownFilter($event.target.value, type)"
            placeholder="{{ 'search' | translate }}..."
          />
        </form>
      </div>
      <hr class="material-menu-separator" />
    }

    <!-- Client, entity or agrupation selector -->
    @if (elementList) {
      <ul class="navbar-top-dropdown-select">
        @for (element of elementList; track i; let i = $index) {
          <li
            [ngClass]="{ 'navbar-dropdown-highlighted': element[highlight] }"
            (click)="
              resetSearchBox(elementFilter, type);
              updateCurrentElement(element);
              toggleVisibilityFalse()
            "
          >
            @if (element[highlight]) {
              @if (!element.showAllEntity) {
                <div class="navbar-top-selected-virtual-icon">
                  <i class="fas fa-circle"></i>
                  <span>V</span>
                </div>
              } @else {
                <div class="navbar-top-selected-total-virtual-icon">
                  <i class="fas fa-circle"></i>
                  <span>V</span>
                </div>
              }
            }
            <div class="navbar-top-dropdown-option">
              {{ element[attributeShowed] }}
              @if (element[attributeShowed + "Parsed"]) {
                <span>{{ element[attributeShowed + "Parsed"] }}</span>
              }
              @if (element.alias) {
                <span>{{ element.alias }}</span>
              }
            </div>
          </li>
        }
      </ul>
    }
  </div>
</div>
